







































import {Component, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import ShardHistoryForm from '@/components/lfs/Forms/ShardHistoryForm.vue';
import NoteEditForm from '@/components/lfs/Forms/NoteEditForm.vue';
import AddQuestionForm from '@/components/lfs/Forms/AddQuestionForm.vue';
import AddSignatureForm from '@/components/lfs/Forms/AddSignatureForm.vue';
import AddComentForm from '@/components/lfs/Forms/AddComentForm.vue';
import AddAnswersForm from '@/components/lfs/Forms/AddAnswersForm.vue';
import ChangeIncludeQuestionForm from '@/components/lfs/Forms/ChangeIncludeQuestionForm.vue';
import ExportAllForm from '@/components/lfs/Forms/ExportAllForm.vue';
import ExportOneForm from '@/components/lfs/Forms/ExportOneForm.vue';
import AddContactForm from '@/components/lfs/Forms/AddContactForm.vue';
import EditContactForm from '@/components/lfs/Forms/EditContactForm.vue';
import AddLinkForm from '@/components/lfs/Forms/AddLinkForm.vue';
import AddProductForm from '@/components/lfs/Forms/AddProductForm.vue';
import EditProductForm from '@/components/lfs/Forms/EditProductForm.vue';

const dialog = namespace('dialog')

@Component({
  name: "FullDialog",
  components: {
    ShardHistoryForm,
    NoteEditForm,
    AddQuestionForm,
    AddSignatureForm,
    AddComentForm,
    AddAnswersForm,
    ChangeIncludeQuestionForm,
    ExportAllForm,
    ExportOneForm,
    AddContactForm,
    EditContactForm,
    AddLinkForm,
    AddProductForm,
    EditProductForm
  }
})
export default class FullDialog extends Vue {
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Getter('formDialog') protected formDialog: any
  @dialog.Getter('titleDialog') protected titleDialog: any
  @dialog.Getter('subtitleDialog') protected subtitleDialog: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any

  save(){
    alert('Save')
  }
}
